import Immutable from "immutable";
import { handleActions } from "redux-actions";
import { IResponse } from "middleware/api";
import { FILTERS_FAILURE, FILTERS_REQUEST, FILTERS_SUCCESS, FILTERS_CACHE_UPDATE } from "constants/action-types";

export interface IFiltersCache {
    [brandId: string]: {
        [key: string]: Immutable.Map<string, any>;
    };
}

export interface IState {
    error?: Error;
    isFetching: boolean;
    result: any;
    cache: IFiltersCache;
}

export const initialState: IState = {
    error: undefined,
    isFetching: false,
    result: [],
    cache: {},
};

export const filtersReducer = handleActions<IState, any>(
    {
        [FILTERS_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                result: [],
            };
        },
        [FILTERS_SUCCESS]: (state: IState, { result }: IResponse): IState => {
            return {
                ...state,
                isFetching: false,
                result,
            };
        },
        [FILTERS_FAILURE]: (state: IState, { error }: IResponse): IState => {
            return {
                ...state,
                error,
                isFetching: false,
                result: [],
            };
        },
        [FILTERS_CACHE_UPDATE]: (state: IState, { payload }: { payload: IFiltersCache }): IState => {
            return {
                ...state,
                cache: {
                    ...state.cache,
                    ...payload,
                },
            };
        },
    } as any,
    initialState,
);
